import { Box } from "@mui/material";
import SectionNavTemplate from "./SectionNavTemplate";
import SectionContentTemplate from "./SectionContentTemplate";
import ProgressBar from "./ProgressBar";

export default function ({
  navWrapper: NavWrapper,
  navProps,
  contentProps,
  children,
  className,
  ml,
  percentComplete,
  leftLabel,
  rightLabel, NextId,
  IsSectionCompleted,
  modifiedData,
  isLink
}) {
  return (
    <Box className={className} >
      {NavWrapper ? (
        <>
          <Box
            border={1}
            borderLeft={1}
            borderRight={1}
            hidden={ml}
            borderColor="#e4e7ec" sx={{ marginTop: 0, padding: 2, marginBottom: 2, borderRadius: "3px", marginRight: 1, backgroundColor: "#fff" }}>
            <ProgressBar
              percentComplete={Number(percentComplete)}
              leftLabel={leftLabel}
              rightLabel={rightLabel}
            />
          </Box>

          <Box className="section-nav-container">
          <span style={{textTransform:"uppercase",fontSize:"16px",fontWeight:600}}>Questionnaire menu</span>

            {navProps && <SectionNavTemplate modifiedData={modifiedData} ml={ml} NextId={NextId} IsSectionCompleted={IsSectionCompleted} {...navProps}  isLink={isLink}/>}
          </Box>
        </>
      ) : (
        navProps && <SectionNavTemplate modifiedData={modifiedData} ml={ml} NextId={NextId}  IsSectionCompleted={IsSectionCompleted} {...navProps} isLink={isLink}/>
      )}
      <SectionContentTemplate {...contentProps} >
        {children}
      </SectionContentTemplate>
    </Box>
  );
}
